import { OrderDocumentType } from '@savgroup-front-common/types';

import { orderDocumentTypeMessages } from './messages/orderDocumentTypeMessages';

export const getOrderDocumentTypeMessage = (
  orderDocumentType: OrderDocumentType,
) => {
  return orderDocumentTypeMessages[orderDocumentType];
};
